<template>
  <v-content
    :class="[
      'accent',
      $vuetify.breakpoint.smAndUp ? 'px-5' : 'px-3',
    ]"
    v-resize="onResize"
  >
    <v-dialog v-if="courseSelect" v-model="dialogCourse" max-width="600" scrollable>
      <v-card>
        <v-card-title class="headline font-weight-bold flex-nowrap">
          {{ courseSelect.titulo }}
          <v-spacer></v-spacer>
          <v-btn icon @click="courseSelect = undefined; dialogCourse = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle class="d-flex flex-column">
          Para más información escríbenos
          <div class="d-flex align-center">
            <v-icon color="success" class="mr-2">mdi-whatsapp</v-icon>
            <span class="font-weight-bold success--text">{{siteSettings.redes_sociales.whatsapp}}</span>
          </div>
        </v-card-subtitle>
        <v-card-text>
          <v-img v-if="!courseSelect.video" :src="courseSelect.portada" contain></v-img>
          <iframe
            v-else
            style="width: 100%"
            height="409"
            :src="courseSelect.video.replace('watch?v=', 'embed/')"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <div class="mt-6 subtitle">{{ courseSelect.descripcion }}</div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCourses" fullscreen scrollable>
      <v-card>
        <v-card-title class="display-2">
          Cursos
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogCourses = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text v-if="typeCourse === 'activos'" class="pt-8 d-flex flex-wrap justify-center">
          <Course
            v-for="(course, index) in coursesActives"
            :key="index"
            :course="course"
            @click.stop="courseSelect = course; dialogCourse = true;"
          />
        </v-card-text>
        <v-card-text
          v-else-if="typeCourse === 'terminados'"
          class="pt-8 d-flex flex-wrap justify-center"
        >
          <Course
            v-for="(course, index) in coursesComplete"
            :key="index"
            :course="course"
            @click.stop="courseSelect = course; dialogCourse = true;"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-container>
      <!-- principal -->
      <v-row
        class="justify-space-between align-center fill-height"
        :style="{ height: `${windowSize.y - 64}px` }"
        v-if="siteSettings && siteSettings.pagina_postulante && siteSettings.pagina_postulante.principal"
      >
        <v-col cols="12" sm="7" md="7" class="mb-10">
          <p
            v-if="siteSettings.pagina_postulante.principal.titulo"
            :class="[
            $vuetify.breakpoint.mdAndUp ? 'display-3' : 'display-1',
            'font-weight-bold',
            'mb-1',
          ]"
          >{{ siteSettings.pagina_postulante.principal.titulo }}</p>
          <p
            v-if="siteSettings.pagina_postulante.principal.subtitulo"
            :class="[
              $vuetify.breakpoint.mdAndUp ? 'display-3' : 'display-1',
              'font-weight-thin',
              'mb-8',
            ]"
          >{{ siteSettings.pagina_postulante.principal.subtitulo }}</p>
          <div class="d-flex">
            <v-hover v-slot:default="{ hover }">
              <v-text-field
                v-model="searchJob"
                label="Puesto, empresa o palabra clave"
                solo
                background-color="white"
                hide-details
                clearable
                flat
                @keypress.enter="search()"
                class="mr-1"
                :style="{
                  borderRadius: 0,
                  borderLeft: 'thick solid var(--v-primary-base)',
                  boxShadow: `0px ${hover ? '6px 35px rgba(0, 0, 0, 0.2)' : '6px 30px rgba(0, 0, 0, 0.08)'} !important`,
                }"
              ></v-text-field>
            </v-hover>
            <v-btn
              :style="{
                height: 'auto !important',
                boxShadow: '0px 6px 30px rgba(0, 0, 0, 0.08) !important',
              }"
              tile
              depressed
              color="primary"
              @click="search()"
            >
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" sm="5" md="5" v-if="$vuetify.breakpoint.smAndUp" class="text-right">
          <v-img src="../assets/home-portada.svg" contain></v-img>
        </v-col>
      </v-row>
      <!-- companies -->
      <v-row v-if="companies.length">
        <v-col cols="12" class="text-center headline">
          <span
            :class="[
              $vuetify.breakpoint.smAndUp ? 'display-1' : 'headline',
              'font-weight-light',
              'grey--text'
            ]"
          >{{siteSettings && siteSettings.pagina_postulante && siteSettings.pagina_postulante.empresas ? siteSettings.pagina_postulante.empresas.titulo : 'Empresas asociadas en las que puedes trabajar'}}</span>
        </v-col>
        <v-col
          v-if="siteSettings && siteSettings.pagina_postulante && siteSettings.pagina_postulante.empresas && siteSettings.pagina_postulante.empresas.descripcion"
          cols="12"
          class="text-center mt-2"
        >
          <span
            class="subtitle-1 grey--text"
          >{{siteSettings.pagina_postulante.empresas.descripcion}}</span>
        </v-col>
        <v-col cols="12">
          <InfiniteAutoPlayCarousel :companies="companies" />
        </v-col>
      </v-row>
      <!-- caracteristicas -->
      <v-row
        class="py-10 mb-10 justify-center"
        v-if="siteSettings && siteSettings.pagina_postulante && siteSettings.pagina_postulante.caracteristicas"
      >
        <v-col
          cols="12"
          :class="[
            'text-center',
            $vuetify.breakpoint.smAndUp ? 'title' : 'subtitle',
            'font-weight-light',
            'px-10',
            'ma-auto',
            'mb-9',
          ]"
          style="max-width: 800px"
          v-if="siteSettings && siteSettings.pagina_postulante && siteSettings.pagina_postulante.caracteristicas && siteSettings.pagina_postulante.caracteristicas.descripcion"
        >{{ siteSettings.pagina_postulante.caracteristicas.descripcion }}</v-col>
        <div
          v-if="siteSettings.pagina_postulante.caracteristicas.caracteristicas && siteSettings.pagina_postulante.caracteristicas.caracteristicas.length"
          class="d-flex flex-wrap"
        >
          <v-col
            v-for="(caracteristicas, index) of siteSettings.pagina_postulante.caracteristicas.caracteristicas"
            :key="index"
            cols="12"
            :sm="siteSettings.pagina_postulante.caracteristicas.caracteristicas.length >= 3
              ? 6
              : siteSettings.pagina_postulante.caracteristicas.caracteristicas.length === 2 ? 6 : 12"
            :lg="siteSettings.pagina_postulante.caracteristicas.caracteristicas.length >= 3
              ? 4
              : siteSettings.pagina_postulante.caracteristicas.caracteristicas.length === 2 ? 6 : 12"
          >
            <div class="d-flex justify-center">
              <v-img width="300" height="250" :src="caracteristicas.imagen" contain></v-img>
            </div>
            <p
              :class="[
                'font-weight-bold',
                $vuetify.breakpoint.smAndUp ? 'headline' : 'title',
              ]"
            >{{ caracteristicas.titulo }}</p>
            <span
              :class="[
                'subtitle',
              ]"
            >{{ caracteristicas.descripcion }}</span>
          </v-col>
        </div>
      </v-row>
      <!-- postulantes registrados -->
      <v-row v-if="siteSettings && postulantsCorrect.length" class="py-10 my-10">
        <v-col :class="{ 'px-0': !$vuetify.breakpoint.smAndUp }">
          <v-container class="pt-10">
            <v-row class="mb-0">
              <v-col class="d-flex align-center pa-0">
                <span
                  :class="[
                    $vuetify.breakpoint.smAndUp ? 'display-3' : 'display-1',
                    'font-weight-thin',
                  ]"
                >{{siteSettings.pagina_postulante.postulantes ? siteSettings.pagina_postulante.postulantes.titulo : 'Miembros de nuestra comunidad'}}</span>
                <v-spacer></v-spacer>
              </v-col>
              <v-col
                v-if="siteSettings && siteSettings.pagina_postulante && siteSettings.pagina_postulante.postulantes && siteSettings.pagina_postulante.postulantes.descripcion"
                cols="12"
                class="text-left mt-2 pl-0"
              >
                <span
                  class="subtitle-1 grey--text"
                >{{siteSettings.pagina_postulante.postulantes.descripcion}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-carousel cycle height="250" hide-delimiter-background show-arrows-on-hover>
                  <v-carousel-item v-for="(postulante, i) in postulantsCorrect" :key="i">
                    <v-sheet
                      height="100%"
                      :class="[ $vuetify.breakpoint.smAndUp ? 'px-12' : 'px-0', 'd-flex', 'justify-center', 'align-center']"
                      color="accent"
                      tile
                    >
                      <BaseMyCard :class="['white', 'd-flex', 'justify-center', 'align-center', $vuetify.breakpoint.smAndUp ? 'mx-12' : 'mx-0', 'py-6', 'px-10']">
                        <div>
                          <v-avatar
                            :color="!postulante.informacion_personal.profile_image ? 'primary' : ''"
                            size="100"
                            class="mr-4"
                          >
                            <v-img
                              v-if="postulante.informacion_personal.profile_image"
                              :src="`${host}${postulante.informacion_personal.profile_image}`"
                              aspect-ratio="1"
                              lazy-src="@/assets/placeholder-image.gif"
                            ></v-img>
                            <span
                              v-else
                              class="white--text display-1 font-weight-bold"
                            >{{ initialsName(postulante) }}</span>
                          </v-avatar>
                        </div>
                        <div>
                          <div
                            class="headline font-weight-bold primary--text"
                          >{{ postulante.informacion_personal.nombres }} {{ postulante.informacion_personal.apellidos }}</div>
                          <div
                            class="body-2 font-weight-light grey--text text--darken-2"
                          >{{ postulante.objetivo_laborals.objetivo }}</div>
                        </div>
                      </BaseMyCard>
                    </v-sheet>
                  </v-carousel-item>
                </v-carousel>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
      <!-- empleos recientes -->
      <v-row class="py-10 my-10" v-if="jobs && jobs.length">
        <v-col :class="{ 'px-0': !$vuetify.breakpoint.smAndUp }">
          <v-container class="pt-10">
            <v-row class="mb-10">
              <v-col class="d-flex align-center pa-0">
                <span
                  :class="[
                    $vuetify.breakpoint.smAndUp ? 'display-3' : 'display-1',
                    'font-weight-thin',
                  ]"
                >{{siteSettings && siteSettings.pagina_postulante && siteSettings.pagina_postulante && siteSettings.pagina_postulante.empleos_recientes ? siteSettings.pagina_postulante.empleos_recientes.titulo : 'Empleos recientes'}}</span>
                <v-spacer></v-spacer>
              </v-col>
              <v-col
                v-if="siteSettings && siteSettings.pagina_postulante && siteSettings.pagina_postulante.empleos_recientes && siteSettings.pagina_postulante.empleos_recientes.descripcion"
                cols="12"
                class="text-left mt-2 pl-0"
              >
                <span
                  class="subtitle-1 grey--text"
                >{{siteSettings.pagina_postulante.empleos_recientes.descripcion}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                :class="[{ 'px-0': !$vuetify.breakpoint.smAndUp }, 'py-0']"
                v-for="job in jobs"
                :key="job.id"
              >
                <CardNotice
                  :small="true"
                  :job="job"
                  :to="{ name: 'jobs by id', params: { id: job._id } }"
                  :user="usuario"
                ></CardNotice>
              </v-col>
            </v-row>
            <v-row>
              <v-spacer></v-spacer>
              <v-btn :to="{ name: 'jobs' }" text rounded color="primary" class="mr-5">
                Ver más
                <v-icon class="ml-2" small>mdi-arrow-right</v-icon>
              </v-btn>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
      <!-- galeria -->
      <v-row v-if="galeria && galleryOnlyActive.length">
        <v-col>
          <v-container fluid class="pa-0">
            <v-row>
              <v-col cols="12">
                <v-carousel cycle height="400" hide-delimiter-background show-arrows-on-hover dark>
                  <v-carousel-item
                    v-for="(imagen, i) in galleryOnlyActive"
                    :key="i"
                    :src="imagen.portada"
                    reverse-transition="fade-transition"
                    transition="fade-transition"
                  >
                    <div
                      class="py-2 px-4"
                      style="height: 50%; background-image: linear-gradient(rgba(0,0,0,0.3), transparent);"
                    >
                      <span
                        class="white--text headline font-weight-light"
                        style="opacity: 1 !important"
                      >{{ imagen.titulo }}</span>
                    </div>
                    <div
                      class="pt-2 pb-10 px-4 d-flex align-end"
                      style="height: 50%; background-image: linear-gradient(transparent, rgba(0,0,0,0.3));"
                    >
                      <span
                        class="white--text title font-weight-light"
                        style="opacity: 1 !important"
                      >{{ imagen.descripcion }}</span>
                    </div>
                  </v-carousel-item>
                </v-carousel>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
      <!-- cursos -->
      <v-row class="pb-10 my-10" v-if="coursesActives && coursesActives.length">
        <v-col>
          <v-container class="pa-0">
            <v-row class="mb-10">
              <v-col class="d-flex align-center pa-0">
                <v-spacer v-if="$vuetify.breakpoint.smAndUp"></v-spacer>
                <span
                  :class="[
                    $vuetify.breakpoint.smAndUp ? 'display-3' : 'display-1',
                    'font-weight-thin',
                  ]"
                >{{siteSettings && siteSettings.pagina_postulante && siteSettings.pagina_postulante.cursos ? siteSettings.pagina_postulante.cursos.titulo : 'Estudia con nosotros'}}</span>
              </v-col>
              <v-col
                v-if="siteSettings && siteSettings.pagina_postulante && siteSettings.pagina_postulante.cursos && siteSettings.pagina_postulante.cursos.descripcion"
                cols="12"
                class="text-right mt-2 pr-0"
              >
                <span
                  class="subtitle-1 grey--text"
                >{{siteSettings.pagina_postulante.cursos.descripcion}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <div
                  :class="[
                    'd-flex', `${$vuetify.breakpoint.mdAndUp ? 'justify-end' : 'justify-center'}`, 'flex-wrap'
                  ]"
                >
                  <Course
                    v-for="(course, index) in coursesActives"
                    v-if="index < 3"
                    :key="index"
                    :course="course"
                    @click.stop="courseSelect = course; dialogCourse = true;"
                  />
                </div>
              </v-col>
            </v-row>
            <v-row v-if="coursesActives.length > 3">
              <v-spacer></v-spacer>
              <v-btn
                @click="typeCourse = 'activos'; dialogCourses = true"
                text
                rounded
                color="primary"
                class="mr-6"
              >
                Ver más
                <v-icon class="ml-2" small>mdi-arrow-right</v-icon>
              </v-btn>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
      <!-- cursos terminados -->
      <v-row class="my-10" v-if="coursesComplete && coursesComplete.length">
        <v-col>
          <v-container class="pa-0">
            <v-row class="mb-10">
              <v-col class="d-flex align-center pa-0">
                <span
                  :class="[
                    $vuetify.breakpoint.smAndUp ? 'display-3' : 'display-1',
                    'font-weight-thin',
                  ]"
                >{{siteSettings && siteSettings.pagina_postulante && siteSettings.pagina_postulante.cursos_finalizados ? siteSettings.pagina_postulante.cursos_finalizados.titulo : 'Cursos impartidos'}}</span>
              </v-col>
              <v-col
                v-if="siteSettings && siteSettings.pagina_postulante && siteSettings.pagina_postulante.cursos_finalizados && siteSettings.pagina_postulante.cursos_finalizados.descripcion"
                cols="12"
                class="text-left mt-2 pl-0"
              >
                <span
                  class="subtitle-1 grey--text"
                >{{siteSettings.pagina_postulante.cursos_finalizados.descripcion}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <div
                  :class="[
                    'd-flex', `${$vuetify.breakpoint.mdAndUp ? 'justify-start' : 'justify-center'}`, 'flex-wrap'
                  ]"
                >
                  <Course
                    v-for="(course, index) in coursesComplete"
                    v-if="index < 3"
                    :key="index"
                    :course="course"
                    @click.stop="courseSelect = course; dialogCourse = true;"
                  />
                </div>
              </v-col>
            </v-row>
            <v-row v-if="coursesComplete.length > 3">
              <v-spacer></v-spacer>
              <v-btn
                @click="typeCourse = 'terminados'; dialogCourses = true"
                text
                rounded
                color="primary"
                class="mr-6"
              >
                Ver más
                <v-icon class="ml-2" small>mdi-arrow-right</v-icon>
              </v-btn>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import { mapState } from "vuex";
import CardNotice from "@/components/CardNotice";
import InfiniteAutoPlayCarousel from "@/components/InfiniteAutoPlayCarousel";
import store from "@/store";

import config from '@/config';

import Course from "@/components/Course.vue";
import { windowSizeMixin } from "@/mixin/windowSizeMixin.js";

export default {
  mixins: [windowSizeMixin],
  name: "Home",
  components: {
    CardNotice,
    Course,
    InfiniteAutoPlayCarousel
  },
  data() {
    return {
      searchJob: "",
      dialogCourse: false,
      dialogCourses: false,
      courseSelect: undefined,
      host: config.host,
      items: [
        {
          title: "Rápido",
          description: "Comunicación directa con empresas",
          color: "amber",
          icon: "mdi-flash"
        },
        {
          title: "Confiable",
          description: "Información privada, tu decides quién te ve",
          color: "pink",
          icon: "mdi-certificate"
        },
        {
          title: "Seguro",
          description: "Gestión de los datos empresariales y personales",
          color: "cyan",
          icon: "mdi-shield-check"
        }
      ],
      jobs: [],
      companies: [],
      postulants: [],
      typeCourse: ""
    };
  },
  computed: {
    ...mapState(["siteSettings", "courses", "galeria"]),
    ...mapState("postulants/postulant", ["usuario"]),
    coursesActives() {
      return this.courses ? this.courses.filter(course => course.estado) : [];
    },
    coursesComplete() {
      return this.courses ? this.courses.filter(course => !course.estado) : [];
    },
    galleryOnlyActive() {
      return this.galeria ? this.galeria.filter(imagen => imagen.estado) : [];
    },
    postulantsCorrect() {
      return this.postulants.filter(
        postulant =>
          postulant.informacion_personal &&
          postulant.informacion_personal.nombres &&
          postulant.informacion_personal.apellidos &&
          postulant.objetivo_laborals &&
          postulant.objetivo_laborals.objetivo
      );
    }
  },
  created() {
    if (
      this.siteSettings &&
      this.siteSettings.empresas &&
      this.siteSettings.empresas.activas
    ) {
      this.retrieveCompaniesActives();
    } else {
      this.retrieveCompanies();
    }
    this.retrieveCourses();
    this.retrieveRecentWorks();
    this.retrieveGallery();
    this.retrievePostulantes();
  },
  methods: {
    initialsName(postulante) {
      const nombres = postulante.informacion_personal.nombres;
      const apellidos = postulante.informacion_personal.apellidos;
      if (nombres && !apellidos) return nombres[0].toUpperCase();
      else if (!nombres && apellidos) return apellidos[0].toUpperCase();
      else if (nombres && apellidos)
        return `${nombres[0].toUpperCase()}${apellidos[0].toUpperCase()}`;
      else return "";
    },
    search() {
      this.$router.push({
        name: "jobs",
        query: { [`filter[all]`]: this.searchJob }
      });
    },
    retrieveCourses() {
      if (!this.courses) {
        store.dispatch("retrieveCourses");
      }
    },
    retrieveGallery() {
      if (!this.galeria) {
        store.dispatch("retrieveGallery");
      }
    },
    retrieveCompanies() {
      store.dispatch("retrieveCompanies").then(companies => {
        this.companies = companies;
      });
    },
    retrieveCompaniesActives() {
      store.dispatch("retrieveCompaniesActives").then(companies => {
        this.companies = companies.map(company => company.empresa);
      });
    },
    retrievePostulantes() {
      store.dispatch("retrievePostulantes").then(postulants => {
        this.postulants = postulants;
      });
    },
    retrieveRecentWorks() {
      store
        .dispatch("job/retrieveRecentWorks")
        .then(jobs => {
          this.jobs = jobs;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
